import { syncRolesToDownstream, syncOneUserToDownstream } from "@/service/structure.js";
export default {
  name: "AppDetailTab8",
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      accountLoading: false,
      roleLoading: false,
      mobile: ""
    };
  },
  methods: {
    /*
     * 手机号校验
     */
    validMobile() {
      if (this.mobile === "") {
        this.$Message.warning($t("a2zp0d6", "请填写手机号"));
        return false;
      } else {
        let reg = /^1[0-9]{10}$/;
        if (!reg.test(this.mobile)) {
          this.$Message.warning($t("tmaknjg", "手机号应为11位的数字,且1开头"));
          return false;
        } else {
          return true;
        }
      }
    },
    /*
     * 账号
     */
    async onChangeAccount() {
      let valid = this.validMobile();
      if (valid) {
        const params = {
          downstream: "OPERA_CLOUD",
          mobile: this.mobile
        };
        this.accountLoading = true;
        let res = await syncOneUserToDownstream(params);
        this.accountLoading = false;
        if (res.data && res.data.result === 0) {
          this.$Message.success($t("b1twyw4", "同步成功"));
        }
      }
    },
    /*
     * 角色
     */
    async onChangeRole(increment) {
      this.roleLoading = true;
      let res = await syncRolesToDownstream("OPERA_CLOUD", increment);
      this.roleLoading = false;
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("b1twyw4", "同步成功"));
      }
    }
  }
};